import { render, staticRenderFns } from "./Maintainers.vue?vue&type=template&id=59eda56e&scoped=true&"
import script from "./Maintainers.vue?vue&type=script&lang=js&"
export * from "./Maintainers.vue?vue&type=script&lang=js&"
import style0 from "./Maintainers.vue?vue&type=style&index=0&id=59eda56e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59eda56e",
  null
  
)

export default component.exports